import BaseModel from './BaseModel';

export default class ItSpend extends BaseModel {
  static fields = [
    { key: 'region', type: 'string', stringify: true },
    { key: 'percentage', type: 'string', stringify: true },
  ];
}
